import * as React from "react";
import Component from "../../AbstractComponent";
import { PaymentInterface } from "../../../Entity/Entities/Payment/PaymentInterface";

export default class Payment2State extends Component {
  public state = {

  };

  constructor(public props) {
    super(props);
  }

  public renderRemovedState = () => {
    return (
      <div style={{ fontSize: "16px", color: "#F44336" }}>
        {this.trans("payment-summary-state/removed").toUpperCase()}
      </div>
    );
  }

  public renderUnusedState = () => {
    return (
      <div style={this.props.isSettled ? { fontSize: "16px", color: "#757575" } : { fontSize: "16px", color: "#F44336" }}>
        {this.trans("payment-summary-state/unused").toUpperCase()}
      </div>
    );
  }

  public renderUsedState = () => {
    return (
      <div style={{ fontSize: "16px", color: "#43A047" }}>
        {this.trans("payment-summary-state/used").toUpperCase()}
      </div>
    );
  }

	public renderPartialUsedState = (payment: PaymentInterface) => {
		return (
			<div>
				<div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-end"}}>
					<div className="class" style={{fontSize: "16px"}}>
						{this.props.isSettled ?
              this.trans("status-used").toLowerCase()
              : this.trans("payment-summary-state/part-unused")}
					</div>
					<div className="currency" style={{fontSize: "16px"}}>
						{payment?.currency?.getIso()}
					</div>
					<div className="amount" style={this.props.isSettled ? { fontSize: "16px", color: "#757575" } : {color: "#F5A623", fontSize: "16px"}}>
						{this.props.isSettled ? this.formatter.formatNumber(this.props.settlementAmount) : this.formatter.formatNumber(payment?.amountRemaining)}
					</div>
				</div>
			</div>
		);
	}

  public renderContent = (payment: PaymentInterface) => {
    if (payment?.removed) {
      return this.renderRemovedState();
    }

		if (payment?.amountUsed === 0) {
			return this.renderUnusedState();
		}

    if (!this.props.isSettled) {
      if (payment?.isFullyUsed()) {
        return this.renderUsedState();
      }
  
      if (payment?.amountRemaining > 0) {
        return this.renderPartialUsedState(payment);
      }
    } else {
      if (payment?.amount === this.props.settlementAmount) {
        return this.renderUsedState();
      }
  
      if (payment?.amount > this.props.settlementAmount) {
        return this.renderPartialUsedState(payment);
      }
    }

	}
	
  public render() {
    const payment: PaymentInterface = this.props.payment;
    return (
      <div>
        <div
          className={`payment-state-title-presentation payment-state`}
          style={{
            padding: "0",
            fontWeight: "bold",
            fontSize: "16px",
            display: "flex",
            justifyContent: "flex-end"
          }}
        >
          {this.renderContent(payment)}

        </div>
        {
          payment?.isPaidDirectlyToOwner && (
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <div className="list-label creation-type-label"
                style={{ maxWidth: "fit-content", fontWeight: "bold", marginTop: "5px" }}
              >
                {this.trans("label-direct")}
              </div>
            </div>

          )
        }
      </div>

    );
  }
}
